import { forwardRef, ComponentProps } from "react";

const EmailIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>((props, svgRef) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16" fill="none" ref={svgRef}>
    <path
      d="M18.75 15.5H1.25C1.08424 15.5 0.925268 15.4342 0.808058 15.3169C0.690848 15.1997 0.625 15.0408 0.625 14.875V1.125C0.625 0.95924 0.690848 0.800269 0.808058 0.683058C0.925268 0.565848 1.08424 0.5 1.25 0.5H18.75C18.9158 0.5 19.0747 0.565848 19.1919 0.683058C19.3092 0.800269 19.375 0.95924 19.375 1.125V14.875C19.375 15.0408 19.3092 15.1997 19.1919 15.3169C19.0747 15.4342 18.9158 15.5 18.75 15.5ZM1.875 14.25H18.125V1.75H1.875V14.25Z"
      fill="currentColor"
    />
    <path
      d="M10 8.85628C9.55234 8.85458 9.12003 8.69274 8.78128 8.40003L0.843781 1.60003C0.717803 1.49229 0.639787 1.33891 0.626893 1.17365C0.620509 1.09181 0.630306 1.00953 0.655723 0.931481C0.681141 0.853436 0.721682 0.781161 0.775031 0.718783C0.828381 0.656405 0.893494 0.605146 0.966654 0.567932C1.03981 0.530718 1.11959 0.508279 1.20142 0.501895C1.36668 0.489002 1.5303 0.542288 1.65628 0.650033L9.59378 7.45628C9.70699 7.55311 9.85106 7.60632 10 7.60632C10.149 7.60632 10.2931 7.55311 10.4063 7.45628L18.3438 0.650033C18.4062 0.596683 18.4784 0.556143 18.5565 0.530725C18.6345 0.505307 18.7168 0.495511 18.7986 0.501895C18.8805 0.508279 18.9602 0.530718 19.0334 0.567932C19.1066 0.605146 19.1717 0.656405 19.225 0.718783C19.2784 0.781161 19.3189 0.853436 19.3443 0.931481C19.3698 1.00953 19.3796 1.09181 19.3732 1.17365C19.3668 1.25548 19.3443 1.33525 19.3071 1.40841C19.2699 1.48157 19.2187 1.54668 19.1563 1.60003L11.25 8.40003C10.9032 8.69982 10.4585 8.86214 10 8.85628Z"
      fill="currentColor"
    />
    <path
      d="M6.52713 8.72785L0.900391 12.479L1.59376 13.5191L7.22051 9.76791L6.52713 8.72785Z"
      fill="currentColor"
    />
    <path
      d="M13.4697 8.73044L12.7764 9.77051L18.4031 13.5217L19.0965 12.4816L13.4697 8.73044Z"
      fill="currentColor"
    />
  </svg>
));

EmailIcon.displayName = "EmailIcon";

export default EmailIcon;
